import React, {useState} from 'react';
import { Modal, Button} from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { 
    deleteItemById,

     } from '../../../../../../../../../../crud/menu_api/items';
import { Item } from '../../../../../../types';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';


interface ModalProps {
  show: boolean;
  handleClose: () => void;
  categoryId?: string;
  items: any[]; 
  setItems: any;
}



interface DeleteItemProps extends ModalProps {
  itemId: string | undefined;
  items: any[];
  setItems: any;
  setData: (data: any[]) => void;
  originalItems: Item[];
  setOriginalItems: (data: Item[]) => void;
  onItemDeleted?: (deletedItemId: string) => void; // NUEVO
}

export interface Option {
    id: number;
    name: string;
  }


const DeleteItem: React.FC<DeleteItemProps> = ({ show, handleClose, itemId, items,setItems, setData, originalItems, setOriginalItems, onItemDeleted }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = () => {
        setIsLoading(true);
        deleteItemById(Number(itemId)).then((response) => {
            if (response) {
            toast.success('Ítem eliminado exitosamente');
            const updatedOriginalItems = originalItems.filter(ing => ing.id !== itemId);
            setItems(updatedOriginalItems);
            setData(updatedOriginalItems);
            setOriginalItems(updatedOriginalItems);
            if (onItemDeleted && itemId) {
              onItemDeleted(itemId);
            }
            handleClose();
            }
        }).catch((error) => {
            console.error(error);
            toast.error('Error al eliminar el ítem \n' + error?.response?.data?.message );
        }).finally(() => {
            setIsLoading(false)
            });
        };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
      <div className='form-modal-title-container'>
        <Modal.Title className='form-modal-title'>Eliminar Ítem</Modal.Title>
      </div>
        <Button variant="none" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      {isLoading && <MiniLoadingSpinner/>}
      {!isLoading &&
      <Modal.Body>
        <p>¿Estás seguro que quieres eliminar este ítem?</p>
      </Modal.Body>
      }
      <Modal.Footer>
      <div className="form-modal-footer-custom">
        <Button className="form-button-cancel" onClick={handleClose}>Cancelar</Button>
        <Button className="form-button-create" onClick={handleDelete} disabled={isLoading}>Eliminar</Button>
      </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteItem;



